import React, { FunctionComponent } from 'react';
import styles from './SectionDivider.module.scss';

interface IProps {}

const SectionDivider: FunctionComponent<IProps> = () => <div className={styles.base} />;

export default SectionDivider;
